module.exports = __webpack_public_path__ + "static/img/AvenirLTProBook.c76b29d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProBook.svg
// module id = nBH3
// module chunks = 1